import React from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/Brand";

export default function PublicFooter() {
  return (
    <footer className="border-t border-slate-800 bg-navy text-slate-300" data-testid="public-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <BrandLogo light />
            <p className="mt-4 max-w-xs text-sm text-slate-400">
              Private-pay healthcare placement education, agent network, and business-building operating system.
            </p>
          </div>
          <FooterCol title="Platform" links={[
            ["How It Works", "/how-it-works"], ["Services", "/services"], ["Providers", "/providers"],
            ["Commission Opportunities", "/commission-opportunities"], ["Calculator", "/commission-calculator"]]} />
          <FooterCol title="Get Started" links={[
            ["Become a Placement Professional", "/become-a-placement-professional"],
            ["Build Your Own Business", "/build-your-business"], ["Business-in-a-Box", "/business-in-a-box"],
            ["Join", "/join"], ["Login", "/login"]]} />
          <FooterCol title="Company & Legal" links={[
            ["About", "/about"], ["FAQ", "/faq"], ["Terms of Use", "/legal#terms"],
            ["Privacy Policy", "/legal#privacy"], ["Earnings Disclaimer", "/legal#earnings"],
            ["Compliance Notices", "/legal#compliance"]]} />
        </div>
        <div className="mt-12 border-t border-slate-800 pt-8 text-xs text-slate-500">
          <p className="font-semibold uppercase tracking-[0.14em] text-slate-400">Powered by Eagle Healthcare Services, Inc.</p>
          <p className="mt-3 max-w-4xl leading-relaxed">
            Care Placement Pro teaches how to identify private-pay healthcare and support-service needs, develop provider
            networks, and build professional referral relationships. We do not imply employment and do not guarantee
            placements, commissions, customers, revenue, or earnings. Compensation depends on approved written agreements
            and applicable law. Nothing here is medical, legal, or financial advice.
          </p>
          <p className="mt-4">© {new Date().getFullYear()} Care Placement Pro. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-heading text-sm font-semibold text-white">{title}</h4>
      <ul className="mt-4 space-y-2.5">
        {links.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-sm text-slate-400 transition-colors hover:text-white">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
